import axios from 'axios'

// import qs from 'qs'
import useUserStore from '@/store/modules/user'
import router from '@/router/index'
import { ElMessage } from 'element-plus'

const toLogin = () => {
  useUserStore().logout().then(() => {
      router.push({
          name: 'login',
          query: {
              redirect: router.currentRoute.value.path !== '/login' ? router.currentRoute.value.fullPath : undefined
          }
      })
  })
}
const toNotPermission = () => {
  useUserStore().logout().then(() => {
      router.push({
          name: 'not_permission'
      })
  })
}

const api = axios.create({
  baseURL: (import.meta.env.DEV && import.meta.env.VITE_OPEN_PROXY === 'true') ? '/proxy/' : import.meta.env.VITE_APP_API_BASEURL,
  timeout: 1000 * 60,
  responseType: 'json',
})

api.interceptors.request.use(
  (request) => {
    // 全局拦截请求发送前提交的参数
    const userStore = useUserStore()
    // 设置请求头
    if (request.headers) {
      if (userStore.isLogin) {
        request.headers.Token = userStore.token
      }
    }
    // 是否将 POST 请求参数进行字符串化处理
    if (request.method === 'post') {
      // request.data = qs.stringify(request.data, {
      //   arrayFormat: 'brackets',
      // })
    }
    return request
  },
)

const versionJudge = ref(false)

api.interceptors.response.use(
  (response) => {
    /**
     * 全局拦截请求发送后返回的数据，如果数据有报错则在这做全局的错误提示
     * 假设返回数据格式为：{ status: 1, error: '', data: '' }
     * 规则是当 status 为 1 时表示请求成功，为 0 时表示接口需要登录或者登录状态失效，需要重新登录
     * 请求出错时 error 会返回错误信息
     */
     if (response.config.responseType == 'blob') {
        return Promise.resolve(response)
     }else if (response.data.code != 9999) {
        //获取版本号并进行缓存清理
        if(!versionJudge.value && response.data.version){
            const currentVersion = localStorage.getItem('app_version');
            const appVersion = response.data.version
            if (currentVersion !== appVersion) {
                localStorage.setItem('app_version', appVersion);
                window.location.href = window.location.href;
                versionJudge.value = true;
            }
        }
        if (response.data.status === 1) {
            // 请求成功并且没有报错
            return Promise.resolve(response.data)
        }else if (response.data.code == 9998) {
            toNotPermission()
            return Promise.reject(response.data)
        } else {
            ElMessage({
                message: response.data.message,
                type: (response.data.status == 2)?'warning':'error'
            })
            return Promise.reject(response.data)
        }
    } else {
        toLogin()
        return Promise.resolve(response.data)
    }
  },
  (error) => {
    let message = error.message
    if (error.response.data.code == 9999) {
        message = error.response.data.message;
        toLogin()
    }else if (error.response.data.code == 9998) {
        message = error.response.data.message;
        toNotPermission()
    }else if (error.response.data.code == 1000) {
        message = error.response.data.message;
    }
    if (message == 'Network Error') {
        message = '后端网络故障'
    } else if (message.includes('timeout')) {
        message = '接口请求超时'
    } else if (message.includes('Request failed with status code')) {
        message = '接口' + message.substr(message.length - 3) + '异常'
    }
    ElMessage({
        message: message,
        type: 'error'
    })
    return Promise.reject(error)
  },
)

export default api
